import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private requestCount = 0;

  /**
   * Observable for loading state
   */
  public readonly isLoading$: Observable<boolean> =
    this.loadingSubject.asObservable();

  /**
   * Current loading state
   */
  public get isLoading(): boolean {
    return this.loadingSubject.value;
  }

  /**
   * Shows the loader
   */
  show(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  /**
   * Hides the loader
   */
  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  /**
   * Forces loader to hide (useful for error scenarios)
   */
  forceHide(): void {
    this.requestCount = 0;
    this.loadingSubject.next(false);
  }

  /**
   * Gets current request count (useful for debugging)
   */
  getRequestCount(): number {
    return this.requestCount;
  }
}
